var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4974 30.0475C9.1336 30.0475 3.16406 24.0779 3.16406 16.7142C3.16406 9.35039 9.1336 3.38086 16.4974 3.38086C23.8611 3.38086 29.8307 9.35039 29.8307 16.7142C29.8307 24.0779 23.8611 30.0475 16.4974 30.0475ZM15.1675 22.0475L24.5957 12.6194L22.7101 10.7338L15.1675 18.2763L11.3963 14.505L9.51072 16.3907L15.1675 22.0475Z",
    fill: "#66A319"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.c5e3eaa32af445929875b2ebf8cdc7cc.svg";
export { ForwardRef as ReactComponent };